import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class IRTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "IR LEDs" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Infrared LED Status', descriptionColumn: 'Hier können Sie das Verhalten der Infrarot LEDs der Kamera einstellen. Sie können zwischen 2 Modi wählen, zum einen die LEDs dauerhaft ausschalten und zum anderen die LEDs durch den Lichtsensor automatisch einschalten zu lassen.' },
        { actionColumn: 'Zeitplan für IR LEDs', descriptionColumn: 'Falls Sie mit dem automatischen Modus nicht zufrieden sind - z.B. der Nachtmodus schaltet sich zu früh oder zu spät ein - können Sie hier einen fixen Zeitplan eintragen.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

IRTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(IRTable)